import { render } from "./LineChartK.vue?vue&type=template&id=9c437630&scoped=true"
import script from "./LineChartK.vue?vue&type=script&lang=ts"
export * from "./LineChartK.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-9c437630"

export default script